import styles from './OrderCard.module.css';
import { Slider } from '../../components/Slider/Slider';
import { MinSliderCard } from '../Slider/minSliderCard/minSliderCard';

import mainXboxImg from '../../assets/xbox_main-img.svg'

export const OrderCard = ({ status, id, orderPrice, orderItems, schema, style, login, transactionId }) => {

	return (
		<div className={styles.main} style={style}>
			<div className={styles.title_block}>
				<div>
					<p className={styles.number}>{!orderItems ? `Пополнение №${id}` : `Заказ №${id}`}</p>
					<h2>{orderPrice} ₽</h2>
				</div>
				<div
					style={status === 'Создан' ? { backgroundColor: '#474747' } : status === 'Отменен' ? { backgroundColor: '#97030C' } : { backgroundColor: '#16820C'}}
					className={styles.status}
				>
					{status}
				</div>
			</div>
			<div className={styles.line}></div>

			<Slider sliderType="min">
				{orderItems ?
				 orderItems.map((orderItem, index) => {
					if (!schema){
						const isItem = orderItem.itemId !== null;
						const isEdition = orderItem.editionId !== null;
						const data = isItem ? orderItem.item : isEdition ? orderItem.edition : orderItem.subscription;

						return (
							<MinSliderCard
								key={index}
								img={data?.img || data.item?.img}
								title={isEdition ? `${data.item.title} ${data.title}` : data.title}
								price={isItem ? data.price : data.price}
								price_disc={data.price_disc}
								devices={isItem ? data.devices : isEdition ? data.item.devices : null}
								lang={isItem ? data.lang : isEdition ? data.item.lang : null}
								itemId={isItem ? orderItem.itemId : null}
								editionItemId={isEdition ? orderItem.edition.itemId : null}
								editionTitle={isEdition && data.title}
								subscriptionId={isItem ? null : orderItem.subscriptionId}
								subCategory={null}
								subTime={null}
								category={isItem ? 'item' : 'subscription'}
							/>
						);
					} else if(schema === 'PS_sharing'){
						const itemTypePrice = `${orderItem.itemOrder.type}_price`
						const itemTypePriceDisc = `${orderItem.itemOrder.type}_price_disc`

						return (
							<MinSliderCard
								key={index}
								img={orderItem.img}
								title={orderItem.title}
								price={orderItem[itemTypePrice]}
								price_disc={orderItem[itemTypePriceDisc]}
								lang={orderItem.lang}
								devices={orderItem.devices}
								itemId={orderItem.id}
							/>
						);
						
					} else if(schema === 'fifa'){
						return (
							<MinSliderCard
								key={index}
								img={'https://image.api.playstation.com/vulcan/ap/rnd/202507/1617/545c2ee83dd7df16ebf1cdd6bcb039016658974439401189.png'}
								title={orderItem.type === 'game' ? orderItem.title : orderItem.title + ' points'}
								price={orderItem.price}
								price_disc={orderItem.price_disc}
								itemId={orderItem.id}
								disabledLink={true}
							/>
						);
					} else {
						return (
							<MinSliderCard
								key={index}
								img={orderItem.img || mainXboxImg}
								title={schema === 'xbox' ? orderItem.time + ' мес' : orderItem.title}
								price={orderItem.price}
								price_disc={orderItem.price_disc}
								itemId={orderItem.id}
								disabledLink={true}
							/>
						);
					}
				 })
					:
					<MinSliderCard
						img={'https://i.postimg.cc/TwM1XCJS/steam-adding-img.png'}
						title={"Steam"}
						description={"Пополнение"}
						login={`login ${login}`}
						transactionId={transactionId}
					/>
					
					
				}
			</Slider>
		</div>
	);
};
